import { gql } from '@apollo/client';

export const STREAKS_RESULTS_QUERY = gql`
  query {
    play_getStreak {
      currentCount
      currentStarted
      lastUpdated
      longestCount
      longestStarted
      longestEnded
    }
  }
`;

export default STREAKS_RESULTS_QUERY;
